export default __webpack_public_path__ + "static/media/main-img.e5e33650.jpg";